/**
* @name: page-background-set
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-background-set
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item">
    <span class="themeAttr-item-title">{{t('背景设置')}}</span>

    <div class="w100b flex-div-bet" style="margin-bottom: 12px;">
      <div>{{t('背景类型')}}</div>
      <div style="font-size: 13px;">
        <radio-group v-model:value="bgType">
          <radio value="colorBg">{{t('颜色背景')}}</radio>
          <radio value="imgBg">{{t('图片背景')}}</radio>
        </radio-group>
      </div>
    </div>


    <div v-if="bgType==='colorBg'" class="themeAttr-item-body flex-div">
      <use-sel-color ref="useSelCtrlBg" @closeOtherColor="closeOtherColor" @selItem="selItem" style="padding-right: 24px;"/>

      <div class="layout-item" @click="selItem(item)"
           :class="item.id===activeKey?'active':''" v-for="item in layoutAry">
        <div class="item-type-sign">
          <div class="color-div"
               :style="'background-color: '+item.id+';'"></div>
          <span class="layoutItem-type-sign-cuntermark"></span>
          <span class="layoutItem-type-sign-icon"><check-outlined/></span>
        </div>
      </div>
    </div>

    <div v-if="bgType==='imgBg'"  class="themeAttr-item-body flex-div">
      <page-bg-img-sel :curImg="getPageBgImgSrc"/>
    </div>

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-background-set",
});
</script>

<script lang="ts" setup>
import PageBgImgSel from "@/views/dashboard/analysisSet/components/page-bg-img-sel.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {RadioGroup,Radio} from "ant-design-vue";
import {CheckOutlined} from "@ant-design/icons-vue";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import UseSelColor from "@/views/dashboard/analysisSet/components/use-sel-color.vue";
import {useI18n} from "vue-i18n";

const { t } = useI18n();
const {
  getPageBgImgSrc,
  getBackShowType,
  getPageBgColor,
} = useHeaderSetting();

const bgType=ref(unref(getBackShowType)||'colorBg');
watch(bgType,(newVal)=>{
  baseHandler(HandlerEnum.BACK_GROUND_SHOW_TYPE, unref(newVal));
})
const layoutAry = [
  {id: '#eee', color: '#eee'},
  {id: '#E0E9EF', color: '#E0E9EF'},
  {id: '#C5C5C5', color: '#C5C5C5'},
  {id: '#FFF2FB', color: '#FFF2FB'},
  {id: '#EFFFFA', color: '#EFFFFA'},
  {id: '#E4EDFF', color: '#E4EDFF'},
  {id: '#E1E8EF', color: '#E1E8EF'},
  {id: '#FAFAFA', color: '#FAFAFA'},
  {id: '#CFD0ED', color: '#CFD0ED'},
  {id: '#E2E7EF', color: '#E2E7EF'},
  {id: '#F6F6FB', color: '#F6F6FB'},
]

const {prefixCls} = useDesign('page-background-set');
//颜色快变化
const activeKey = ref(unref(getPageBgColor));
const selItem = function (item) {
  activeKey.value = item.id;
  baseHandler(HandlerEnum.BACK_GROUND_COLOR_THEME, item.id)
}

const useSelCtrlBg:any= ref(null);
const closePanel=function (){
  if(useSelCtrlBg.value){
    useSelCtrlBg.value.closePanel();
  }
}
defineExpose({closePanel})

const emits = defineEmits(['closeOtherColor'])
const closeOtherColor=function (){
  emits('closeOtherColor', {});
}
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-background-set';


.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold, PingFang SC;

  .themeAttr-item-body {
    flex-wrap: wrap;
  }

  .layout-item {
    position: relative;
    cursor: pointer;

    .color-div {
      border: 1px solid #dfdfdf;
      width:32px;height:32px;border-radius: 4px;
    }

    &.active {
      .item-type-sign {
        border: 1px solid #ff2121;
      }

      .layoutItem-type-sign-cuntermark {

        border-color: #ff2121 #ff2121 transparent transparent;
      }

      .layoutItem-type-sign-icon {
        color: #fff;
      }
    }

    .layoutItem-type-sign-icon {
      position: absolute;
      top: -1px;
      right: 0.5px;
      width: 20px;
      height: 20px;
      font-size: 9px;
      z-index: 2;
      color: transparent;
      font-weight: bold;
    }

    .layoutItem-type-sign-cuntermark {
      position: absolute;
      top: 0;
      right: 13px;
      width: 16px;
      height: 16px;
      border: 8px solid transparent;
      z-index: 1;
    }
  }

  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }

  .itme-title-span {
    text-align: center;
    margin-top: 6px;
  }

  .item-type-sign {
    width: 40px;
    height: 40px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 12px;
  }
}
</style>
